import { Box, Divider, Skeleton, useTheme } from "@mui/material";
import NextActionCard from "./next-action-card";
import { Fragment } from "react/jsx-runtime";
import useTrackNextActions from "../../hooks/track-next-actions.hook";
import { NextActionDto } from "../../types";
import EmptySection from "@/modules/common/components/ui/empty-section";
import useScreenSize from "@/modules/common/hooks/device-detection.hook";
import GenericAccordion from "@/modules/common/components/ui-kit/generic-accordion";

const NextActionsSkeleton = () => {
  const theme = useTheme();

  return (
    <Fragment>
      <Box sx={{ width: "100%", height: "100%" }}>
        <Box sx={{ padding: 1 }}>
          <Skeleton animation="wave" sx={{ width: "40%" }} />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </Box>
        <Divider
          sx={{
            width: "100%",
          }}
          color={theme.nawy.colors.primitives.grey[500]}
        />
      </Box>
    </Fragment>
  );
};

const NextActions = () => {
  const theme = useTheme();
  const { isMobile } = useScreenSize();

  const { isLoading, data } = useTrackNextActions();

  return (
    <GenericAccordion
      title="Next Actions"
      id="track-next-actions"
      defaultExpanded
      rounded
    >
      {isLoading ? (
        <NextActionsSkeleton />
      ) : (
        <>
          {data &&
            data?.length > 0 &&
            data?.map((action: NextActionDto) => (
              <Fragment key={action.id}>
                <NextActionCard nextAction={action} />

                {!isMobile && (
                  <Divider
                    sx={{
                      width: "100%",
                    }}
                    color={theme.nawy.colors.primitives.grey[500]}
                  />
                )}
              </Fragment>
            ))}

          {!data?.length && <EmptySection title="Next Actions" />}
        </>
      )}
    </GenericAccordion>
  );
};

export default NextActions;
